import {React, useState, useEffect }from "react";
//import { Image } from 'primereact/image';
import { Image } from 'react-bootstrap';
import  noPhoto from "../../../common/image/no photo stub.jpg"
//css
import styles from "./MarketingStockProductMobileView.module.css"
import {useCartContext} from "../../../Context/CartContext";
import {Button} from "primereact/button";
import { Tooltip } from 'primereact/tooltip';
import {useWindowDimensions} from "../../../Context/WindowDimensionsContext";
import {ProductBalance} from "../../../common/constants"

export const MarketingStockProductMobileView = ({id, balance, deliveryDate, index, isSet, productCountFromList, stockId, stockName, productNumber,productName, smallImageUrl, originalImageUrl, reccomendPrice, volume, totalAmount, totalBalance, productPrice, productStockPrice, productPriceList, toast}) => {

    const {addStockProductToCart} = useCartContext();
    const {viewPortWidth,viewPortHeight} = useWindowDimensions();
    const [productWrapperStyle, setProductWrapperStyle] = useState({display: 'grid'});

    //balance
    const [productBalanceStatus, setProductBalanceStatus] = useState(ProductBalance.InStock)
    const [productButton, setProductButton] = useState(<Button/>)
    const [buyButtonLabel, setBuyButtonLabel] = useState('')
    const [buyBtnDisabled, setBuyBtnDisabled] = useState(false)

    useEffect(() => {
        if(isSet && viewPortWidth < 1000){
            setProductWrapperStyle({gridTemplateColumns: '1fr 3fr !important'});
        }
    }, [isSet])

    useEffect(() => {
        let balanceStatus = '';
        let btnLabel = 'В кошик'
        let btnDisabled = false;
        //let prodButton = (<Button label="В кошик" style={{fontSize:'16px', fontFamily:'Commissioner', fontWeight:'500', color:'#666666' }}  onClick={addToCartHandler} className={styles.buyButton}/>)

        if (balance === 0) {
            balanceStatus = ProductBalance.OutOfStock;
            btnDisabled = true;
            if(deliveryDate){
                btnLabel = 'Очікуємо поставки...';
            }
            else{
                btnLabel = 'Немає в наявності';
            }
        }else if (balance >= 6){
            balanceStatus = ProductBalance.Ends;
        }
        else if (balance < 6){
            balanceStatus = ProductBalance.InStock;
        }

        setBuyBtnDisabled(btnDisabled)
        setBuyButtonLabel(btnLabel)
        setProductBalanceStatus(balanceStatus)
        

    }, [balance])

    const addToCartHandler = async () => {
        addStockProductToCart({
            id: id,
            name: productName,
            priceList: productPriceList,
            number: productNumber,
            isDiscount: false,
            recommendPrice: reccomendPrice,
            priceListIndex: 0,
            count: 1,
            calcPrice: 0
        }, stockId, stockName).then((data) => {
            if (data.isSucccess) {
                toast.current.clear();
                toast.current.show({
                    severity: 'success',
                    summary: 'Додано у кошик',
                    clearPrevious: true,
                    detail: productName,
                    life: 1000
                });
            } else {
                toast.current.clear();
                toast.current.show({
                    severity: 'error',
                    summary: 'Помилка',
                    clearPrevious: true,
                    detail: 'Помилка змінення кошика',
                    life: 1000
                });
            }
        })
    }

    return (

         <div className={`${styles.productWrapper} ${productBalanceStatus === ProductBalance.OutOfStock && styles.opacity05} ${productStockPrice != null ? styles.stockProductBorder : styles.baseProductBorder}`} key={id+productNumber+productName + Math.floor(Math.random() * 1001)} >
            <div className={`${ isSet && viewPortWidth < 1000 ? styles.infoWithoutSet : styles.info}`} style={productWrapperStyle}>
                <Image src={smallImageUrl.length > 0 ? smallImageUrl[0] : noPhoto}  alt="Image" style={{width:'100%'}}  />
                <div className={`${styles.name_price}`}>
                    <h5 style={{fontWeight:'700', color: '#495057'}}>{productName}</h5>

                    {isSet === true ?<div>
                        <span>{volume} шт</span>
                        <i style={{marginLeft:'5px'}} data-pr-tooltip="Кількість товару в комплекті" data-pr-position="bottom" className="pi pi-info-circle" rounded='true'  aria-label="Bookmark"></i>
                        <Tooltip target=".pi-info-circle"  />
                    </div> : null}

                    {productStockPrice && productStockPrice.UoMPrice > 0 ?
                        <div>
                            <div className={styles.priceWithOutDiscount}>
                                {productPrice && productPrice.UoMPrice > 0 ? productPrice.UoMPrice.toLocaleString('uk-UA', {
                                    style: 'currency',
                                    currency: 'UAH',
                                    currencyDisplay: 'symbol' }) : null}
                            </div>
                            <div className={styles.priceWithDiscount}>{productPriceList[0].UoMPrice.toLocaleString('uk-UA', {
                                style: 'currency',
                                currency: 'UAH',
                                currencyDisplay: 'symbol' })}
                            </div>
                        </div>

                        :
                        <div style={{marginBottom:'0'}}>{productPriceList[0].UoMPrice.toLocaleString('uk-UA', {
                            style: 'currency',
                            currency: 'UAH',
                            currencyDisplay: 'symbol'})}
                        </div>
                    }

                    {isSet !== true && viewPortWidth > 1000 ? <Button label={buyButtonLabel} disabled={buyBtnDisabled} style={{fontSize:'16px', fontFamily:'Commissioner', fontWeight:'500', color:'#666666' }}  onClick={addToCartHandler} className={styles.buyButton}/> : null}
                    {/*{isSet !== true && viewPortWidth > 1000 ? <Button label="В кошик" style={{fontSize:'17px', fontFamily:'Commissioner', color:'#404040' }}  className={styles.buyButton} onClick={addToCartHandler}/> : null}*/}
                </div>
                {isSet !== true && viewPortWidth <= 1000 ?  <Button icon="pi pi-cart-plus" rounded style={{borderRadius:'50%'}} disabled={buyBtnDisabled}  onClick={addToCartHandler} className={styles.buyButton}/> : null}
            </div>
        </div>
    )
}